// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"department-list_titleContainer__1jVRD","titleEditIcon":"department-list_titleEditIcon__21PF_"};